/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CommentPermissions } from './commentPermissions';
import { UserExtended } from './userExtended';

export interface CommentCommon { 
    entity_id: string;
    creation_date: Date;
    creator: UserExtended;
    text: string;
    permissions: CommentPermissions;
}